import { User } from "@ecologi/shared";
import styled from "@emotion/styled";
import React from "react";
import { Typography } from "../Typography";
import { useBodyClass } from "../utils";
import { Wrapper } from "../Wrapper";
import { YoureAwesome } from "../YoureAwesome";
import { ChildProfileBanner } from "./ChildProfileBanner";
import { FreeSignupForm } from "./FreeSignupForm";

export const Mountains = styled.div`
  background-image: url(/images/app/mountains-background.svg);
  background-position: center;
  background-repeat: repeat-x;
  background-size: 1600px;
  height: 200px;
  width: 100%;

  @media ${({ theme }) => theme.bp.tabletUp} {
    height: 300px;
  }
`;

const Title = styled(Typography)`
  margin-bottom: 12px;
  text-align: center;
`;

const Subtitle = styled(Typography)`
  margin-bottom: 40px;
  text-align: center;
`;

export type FreeAccountSignupProps = {
  children: React.ReactNode;
  hasSignupInitiated: boolean;
  isCheckingUserSession: boolean;
  user: User | null;
  parentUsername?: string;
  parentExists?: boolean | null;
};

export const FreeAccountSignup = ({
  children,
  hasSignupInitiated,
  isCheckingUserSession,
  user,
  parentUsername,
  parentExists,
}: FreeAccountSignupProps) => {
  useBodyClass("bodyMountains");

  if (user && !hasSignupInitiated) {
    return <YoureAwesome user={user} />;
  }

  return (
    <>
      <Wrapper
        isLarge
        style={{ margin: "120px auto 40px", minHeight: "550px" }}
      >
        <Title use="featureTitle" as="h1">
          Complete sign up
        </Title>
        <Subtitle use="subtitle2">
          Register to start funding climate solutions
        </Subtitle>
        {parentUsername && parentExists !== null && (
          <Wrapper>
            <ChildProfileBanner
              parentUsername={parentUsername}
              parentExists={parentExists}
            />
          </Wrapper>
        )}
        {children}
      </Wrapper>
      <Mountains />
    </>
  );
};

FreeAccountSignup.Form = FreeSignupForm;
